'use strict';



const $ = require('jquery');
const api = '/_fragments';



module.exports = function getFragment(path, options = {}) {
	const url = [ api, path ].join('/');
	return $.get(url, options);
};